import { apiPost } from "../_apiShim";

const BASE_PATH = "/api/v1/aws/";

export interface SendEmailRequest {
  recipients: string[];
  /** Optional 24-char ObjectId hex of an example guest whose data fills
   *  the template variables for the test render (delivered to recipients). */
  sampleGuestId?: string;
}

export interface SendEmailResult {
  successCount: number;
  failureCount: number;
  failures?: Array<{
    recipient: string;
    error: string;
  }>;
}

export async function sendEmails(
  eventId: string,
  emailTemplateId: string,
  language: string,
  recipients: string[],
  sampleGuestId?: string
): Promise<SendEmailResult> {
  const requestBody: SendEmailRequest = {
    recipients,
    ...(sampleGuestId ? { sampleGuestId } : {}),
  };

  return await apiPost<SendEmailResult>(
    `${BASE_PATH}${eventId}/ses/send-emails?emailTemplateId=${emailTemplateId}&language=${language}`,
    requestBody,
    {
    }
  );
}
